var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);

// src/constants.ts
var constants_exports = {};
__export(constants_exports, {
  APP_LOCATION: () => APP_LOCATION,
  EventNamePrefix: () => EventNamePrefix,
  EventNames: () => EventNames,
  HostModes: () => HostModes,
  MFE_INSTANCE_ID_QUERY_PARAM: () => MFE_INSTANCE_ID_QUERY_PARAM,
  MFE_LOCATION: () => MFE_LOCATION,
  SPEC_VERSION: () => SPEC_VERSION,
  VERSION: () => VERSION
});
var SPEC_VERSION = "2.2.0";
var VERSION = SPEC_VERSION;
var EventNamePrefix = "storable.mfe";
var EventNames = {
  APPLY_AUTH_TOKEN: `${EventNamePrefix}.applyauthtoken`,
  REQUEST_AUTH_TOKEN: `${EventNamePrefix}.requestauthtoken`,
  EMBEDDED: `${EventNamePrefix}.embedded`,
  EMBED_ACKNOWLEDGED: `${EventNamePrefix}.embedacknowledged`,
  UPDATE_TITLE: `${EventNamePrefix}.updatetitle`,
  UPDATE_DISPLAY: `${EventNamePrefix}.updatedisplay`,
  COMPLETED: `${EventNamePrefix}.completed`,
  CANCELLED: `${EventNamePrefix}.canceled`,
  FATAL_ERROR_ENCOUNTERED: `${EventNamePrefix}.fatalerrorencountered`,
  CLOSING_ACKNOWLEDGED: `${EventNamePrefix}.closingacknowledged`,
  CLOSING_CANCELLED: `${EventNamePrefix}.closingcanceled`,
  CLOSING_STARTED: `${EventNamePrefix}.closingstarted`,
  SUSPENDED: `${EventNamePrefix}.suspended`,
  UNSUSPENDED: `${EventNamePrefix}.unsuspended`,
  MFE_MESSAGE: `${EventNamePrefix}.mfemessage`,
  APP_MESSAGE: `${EventNamePrefix}.appmessage`
};
var HostModes = {
  WebView: "WEB_VIEW",
  iFrame: "IFRAME",
  Standalone: "STANDALONE",
  Direct: "DIRECT"
};
var APP_LOCATION = "APP";
var MFE_LOCATION = "MFE";
var MFE_INSTANCE_ID_QUERY_PARAM = "stMfeInstanceId";

// src/message.ts
var message_exports = {};
__export(message_exports, {
  Message: () => Message
});
var Message = class {
  constructor({
    name,
    source,
    destination,
    instanceUuid,
    payload
  }) {
    this.version = SPEC_VERSION;
    this.name = name;
    this.source = source;
    this.destination = destination;
    this.instanceUuid = instanceUuid;
    this.payload = payload;
  }
  isFrom(location) {
    if (!this.source) return false;
    return this.source.split(".")[0] === location;
  }
  /**
   * Type guard to check if a Message's payload matches the type for its event name.
   * Narrows the type to Message&lt;PayloadMap[T]&gt; if true.
   */
  isNamed(eventName) {
    return this.name === eventName;
  }
};

// src/errors.ts
var errors_exports = {};
__export(errors_exports, {
  InsecureDispatchError: () => InsecureDispatchError,
  MfeError: () => MfeError,
  StandaloneDispatchError: () => StandaloneDispatchError,
  StandaloneNotAllowedError: () => StandaloneNotAllowedError,
  UnknownDestinationError: () => UnknownDestinationError
});
var MfeError = class extends Error {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
  }
};
var StandaloneNotAllowedError = class extends MfeError {
  constructor() {
    super("This MFE is not allowed to be loaded standalone.");
  }
};
var StandaloneDispatchError = class extends MfeError {
  constructor() {
    super("Messages cannot be dispatched in standalone mode");
  }
};
var InsecureDispatchError = class extends MfeError {
  constructor() {
    super("Messages cannot be dispatched to an insecure origin");
  }
};
var UnknownDestinationError = class extends MfeError {
  constructor(destinationId) {
    super(`Unknown destination: ${destinationId}`);
  }
};

// src/uuid.ts
function uuid() {
  if (crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return "10000000-1000-4000-8000-100000000000".replace(
    /[018]/g,
    (c) => {
      const i = parseInt(c, 10);
      return (i ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> i / 4).toString(16);
    }
  );
}

// src/debug.ts
var noopDebug = (..._args) => {
};
var realDebug = (...args) => {
  console.debug(...args);
};
var debugLogger = (shouldDebug) => shouldDebug ? realDebug : noopDebug;

// src/payloads/index.ts
var payloads_exports = {};

export { APP_LOCATION, EventNames, HostModes, InsecureDispatchError, MFE_INSTANCE_ID_QUERY_PARAM, MFE_LOCATION, Message, SPEC_VERSION, StandaloneDispatchError, StandaloneNotAllowedError, UnknownDestinationError, __privateAdd, __privateGet, __privateMethod, __privateSet, constants_exports, debugLogger, errors_exports, message_exports, payloads_exports, uuid };
